import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-animated-button',
  templateUrl: './animated-button.component.html',
  styleUrls: ['./animated-button.component.scss'],
  imports: [NgClass, NgIf],
})

/**
 * Standard button with icon on particular side that animates on hover.
 */
export class AnimatedButtonComponent {
  // The icon for the button, all font awesome icons.
  @Input() public icon: string;
  // The size of the icon (xs, sm, lg, 2x, 3x, 5x, 7x, 10x)
  @Input() public size: string;
  // Color for the button.
  @Input() public color: string;
  // Classes for the button.
  @Input() public class: string;
  // Side to have the icon on (left, right)
  @Input() public direction: string;
  // If the button should be disabled
  @Input() public disabled: boolean = false;
  // If the button is a submit button.
  @Input() public shouldSubmit: boolean = false;
  // If the button is in loading state
  @Input() public loading: boolean = false;
  // The text displayed in the button when loading
  @Input() public loadingText: string;
  // The id of the button
  @Input() public id: string;

  /**
   * getType returns the button type
   */
  public getType(): string {
    return this.shouldSubmit ? 'submit' : 'button';
  }

  /**
   * isDisabled returns the button state (loading or disabled)
   */
  public isDisabled(): boolean {
    return this.disabled || this.loading;
  }

  /**
   * Returns the classes that should be assigned based the components inputs
   */
  public getButtonClasses(): string {
    let btnClasses = 'animated-' + this.direction;

    btnClasses += this.color ? ' is-' + this.color : ' is-primary';

    if (this.class) {
      btnClasses += ` ${this.class}`;
    }

    return btnClasses;
  }

  /**
   * returns the classes for the margin left or right for text label
   */
  public getMarginDirection(): string {
    return `${this.direction}-align-text`;
  }

  /**
   * returns the classes for the icon direction left or right
   */
  public getIconClass(): string {
    let classes = 'fa';

    classes += ' fa-' + (this.loading ? 'spinner fa-spin' : this.icon.replace('fa-', ''));

    if (this.size) {
      classes += ' fa-' + this.size;
    }

    return classes;
  }
}
